/* eslint-disable @typescript-eslint/no-unused-vars */
import { combine } from 'effector';
export function equals(a, b) {
  return combine({
    and: [a, b, (a, b) => a === b, {
      skipVoid: false
    }],
    or: {
      sid: "-pqjlti"
    }
  });
}